const DesignFacade = require('../../../../facade/design/design');
const template = require('./templates/template-color.hbs');
const AnalyticsDecorate = require('../../../../analytics/decorate');

module.exports = AnalyticsDecorate(require('./analytics/color'), Backbone.View.extend({
  events: {
    click: 'clickEvent'
  },

  clickEvent: function (event) {
    DesignFacade.set('background', { color: this.color });
  },

  initialize: function (options) {
    this.editor = INKIVE.Tool.getInstance().editor;
    this.color = options.color;

    this.render();
  },

  render: function () {
    this.$el.html(template({ color: this.color }));
    this.$el.data('attr', 'fill fill-opacity');
    this.$el.attr('title', this.color);
  }
}));
